import React, { useContext, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import { HeadingWrapper } from "../Atomics/SectionHeader/SectionHeader";
import { ProfileContext } from "../../context/profile";
import { accountUpgradeFetcher, profileFetcher } from "../../api/requests";
import { useToaster } from "../../context/toaster";
import { baseURL } from "../../api/dataFetcher";
import Cookies from "js-cookie";

const Settings = () => {
  const { profile, updateProfile } = useContext(ProfileContext);
  const [formData, setFormData] = useState({
    first_name: profile?.first_name || "",
    last_name: profile?.last_name || "",
    image: null,
    description: profile?.description || "",
    sex: profile?.sex || "",
    province: profile.province || "",
    city: profile?.city || "",
    job: profile?.job || "",
    education: profile?.education || "",
  });
  const [previewImage, setPreviewImage] = useState(profile?.image || null);
  const { addMessage } = useToaster();
  const [errors, setErrors] = useState({
    status: false,
    messages: [],
  });
  const [parsedUser, setParsedUser] = useState();

  useEffect(() => {
    const user = Cookies.get("vaghfnamaUser");
    if (user) {
      const parsed = JSON.parse(user);
      setParsedUser(parsed);
    }
  }, []);

  useEffect(() => {
    if (profile.user) {
      setFormData({
        first_name:
          profile.first_name.substring(0, 4) ===
          parsedUser?.username.substring(7)
            ? ""
            : profile.first_name || "",
        last_name: profile.last_name || "",
        image: null,
        description: profile?.description || "",
        sex: profile?.sex || "",
        province: profile.province || "",
        city: profile?.city || "",
        job: profile?.job || "",
        education: profile?.education || "",
      });
      setPreviewImage(profile.image || null);
    }
  }, [profile.user]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        image: file,
      }));
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataToSubmit = new FormData();

    formDataToSubmit.append("user", profile.user);
    formDataToSubmit.append("first_name", formData.first_name);
    formDataToSubmit.append("last_name", formData.last_name);
    formDataToSubmit.append("description", formData.description);
    formDataToSubmit.append("sex", formData.sex);
    formDataToSubmit.append("province", formData.province);
    formDataToSubmit.append("city", formData.city);
    formDataToSubmit.append("job", formData.job);
    formDataToSubmit.append("education", formData.education);

    if (formData.image) {
      formDataToSubmit.append("image", formData.image);
    }
    try {
      const res = await profileFetcher.put(formDataToSubmit);

      if (res) {
        showToast("success", "اطلاعات شما با موفقیت تغییر یافت.");
        setErrors({ ...errors, messages: [""] });
      }
    } catch (error) {
      console.error("setting error:", error);
      showToast("error", "متاسفانه خطایی رخ داده است.");
      setErrors((prevErrors) => ({
        ...prevErrors,
        status: true,
        messages: Object.values(error.response.data),
      }));
    }
  };

  const handleCancelClick = () => {
    setFormData({
      first_name: profile.first_name || "",
      last_name: profile.last_name || "",
      image: profile.image || null,
      description: profile?.description || "",
      sex: profile?.sex || "",
      province: profile.province || "",
      city: profile?.city || "",
      job: profile?.job || "",
      education: profile?.education || "",
    });
    setPreviewImage(profile.image || null);
  };

  const handleAccountUpgrade = async () => {
    try {
      const res = await accountUpgradeFetcher.post(profile.user);
      if (res) {
        alert(
          "درخواست شما با موفقیت ارسال شد، پس از تایید مدیر سایت، حساب کاربری شما ارتقاء می یابد."
        );
      }
    } catch (err) {
      alert(err.response.data[0]);
    }
  };

  return (
    <ContentWrapper>
      <Container
        fluid
        className="upload-details text-right"
        style={{
          // maxWidth: "1500px",
          paddingLeft: "30px",
          paddingRight: "30px",
          minHeight: "calc(100vh - 123px)",
        }}
      >
        <div
          style={{
            paddingTop: "30px",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          <Row>
            <Col>
              <div className="float-right">
                <HeadingWrapper
                  heading={`تنظیمات مربوط به ${parsedUser?.username}`}
                />
              </div>
            </Col>
          </Row>
          <p>
            اگر قصد ارتقاء دسترسی حساب کاربری خود را دارید، باید تمام اطلاعات
            زیر را ثبت کنید.
          </p>
          <Form onSubmit={handleSubmit}>
            <Form.Row>
              <Form.Group as={Col} controlId="image">
                <Form.Label>عکس پروفایل</Form.Label>
                <div className="d-flex align-items-center">
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      overflow: "hidden",
                      marginLeft: "10px",
                    }}
                  >
                    {previewImage && (
                      <img
                        src={baseURL + previewImage}
                        alt="Preview"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    )}
                  </div>
                  <Form.Control type="file" onChange={handleFileChange} />
                </div>
              </Form.Group>
            </Form.Row>

            <Form.Row>
              <Form.Group as={Col} controlId="first_name">
                <Form.Label>نام</Form.Label>
                <Form.Control
                  type="text"
                  placeholder=""
                  value={formData.first_name}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="last_name">
                <Form.Label>نام خانوادگی</Form.Label>
                <Form.Control
                  type="text"
                  placeholder=""
                  value={formData.last_name}
                  onChange={handleChange}
                />
              </Form.Group>
            </Form.Row>

            <Form.Row>
              <Form.Group as={Col} controlId="sex">
                <Form.Label>جنسیت</Form.Label>
                <div>
                  <Form.Check
                    type="radio"
                    label="مرد"
                    name="sex"
                    value="مرد"
                    checked={formData.sex === "مرد"}
                    onChange={handleChange}
                    inline
                    className="sex"
                  />
                  <Form.Check
                    type="radio"
                    label="زن"
                    name="sex"
                    value="زن"
                    checked={formData.sex === "زن"}
                    onChange={handleChange}
                    inline
                    className="sex"
                  />
                </div>
              </Form.Group>

              <Form.Group as={Col} controlId="description">
                <Form.Label>توضیحات</Form.Label>
                <Form.Control
                  type="text"
                  placeholder=""
                  value={formData.description}
                  onChange={handleChange}
                />
              </Form.Group>
            </Form.Row>

            <Form.Row>
              <Form.Group as={Col} controlId="province">
                <Form.Label>استان</Form.Label>
                <Form.Control
                  type="text"
                  placeholder=""
                  value={formData.province}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group as={Col} controlId="city">
                <Form.Label>شهر</Form.Label>
                <Form.Control
                  type="text"
                  placeholder=""
                  value={formData.city}
                  onChange={handleChange}
                />
              </Form.Group>
            </Form.Row>

            <Form.Row>
              <Form.Group as={Col} controlId="education">
                <Form.Label>تحصیلات</Form.Label>
                <Form.Control
                  type="text"
                  placeholder=""
                  value={formData.education}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group as={Col} controlId="job">
                <Form.Label>شغل</Form.Label>
                <Form.Control
                  type="text"
                  placeholder=""
                  value={formData.job}
                  onChange={handleChange}
                />
              </Form.Group>
            </Form.Row>

            <Row>
              <Col className="text-right">
                <Button
                  variant="danger"
                  type="button"
                  onClick={handleCancelClick}
                >
                  لغو
                </Button>
                <Button variant="success mr-1" type="submit">
                  ذخیره تغییرات
                </Button>
              </Col>
            </Row>

            {parsedUser?.role === "nobody" &&
              formData.city &&
              formData.description &&
              formData.education &&
              formData.first_name &&
              formData.job &&
              formData.last_name &&
              formData.province && (
                <Row>
                  <Col className="text-right mt-3">
                    <Button
                      variant="warning"
                      style={{ fontSize: "14px" }}
                      onClick={handleAccountUpgrade}
                    >
                      ارسال درخواست ارتقاء دسترسی
                    </Button>
                  </Col>
                </Row>
              )}
          </Form>
        </div>
        {errors.status &&
          errors.messages.map((item, index) => (
            <p key={index} className="text-danger mt-1">
              {item}
            </p>
          ))}
      </Container>

      <ThinFooter />
    </ContentWrapper>
  );
};

export default Settings;
